<script setup>
import { ref } from 'vue'

import { DxTagBox } from 'devextreme-vue/tag-box'

import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  disabled: { type: Boolean, default: false },
})

const mechanicsMap = (store, allowedIds = []) => {
  const now = Date.now()

  return store.filter(i => i.is_mechanic &&
      (
        !i.deleted_at ||
        new Date(i.deleted_at).getTime() > now ||
        allowedIds.includes(i.id)
      )
  ).map(m => ({
    label: `${m.name} ${m.name_ext}`,
    value: m.id,
  }))
}

const webSiteStore = useWebSiteStore()
const loadedItems = ref(mechanicsMap(webSiteStore.userDetails, props.data.value || []))

const loadMechanicsAsync = async() => {
  const mechanics = await webSiteStore.getOrFetchUserDetailsAsync()
  loadedItems.value = mechanicsMap(mechanics, props.data.value || [])
}

const onOpened = async() => {
  await loadMechanicsAsync()
}
</script>

<template>
  <div>
    <dx-tag-box
      :items="loadedItems"
      :value="props.data.value"
      :show-selection-controls="true"
      :input-attr="{ 'aria-label': 'Mechanics' }"
      :search-enabled="true"
      :apply-value-mode="'useButtons'"
      :multiline="false"
      :max-displayed-tags="1"
      value-expr="value"
      display-expr="label"
      :disabled="props.disabled"
      @value-changed="e => props.data.setValue(e.value)"
      @opened="onOpened"
    />
  </div>
</template>
